import { useEffect, useState } from "react";
import emailjs from 'emailjs-com';
export const useSendEmail = (templateId) => {
    const serviceId = 'gaba_team_inbox';
    const userId = 'user_yIq3IIfTQ8ruKbjBAqYaQ';
    const [isSending, setIsSending] = useState(false)
    const [data, setData] = useState(null)

    const sendEmail = async (templateParams) => {
        setIsSending(true)
        emailjs.send(serviceId, templateId, templateParams, userId)
            .then(response => {
                setData(response)
                setIsSending(false)
            })
    }
    useEffect(() => {
        return () => {

        }
    }, [])

    return [sendEmail, { data, isSending }]
}